import { Dialog } from "@material-ui/core";
import { SmallTitleText, StyledPaper } from "../idpDocuments/styles";
import { InfoArea } from "../../../components/addBankPopup/styles";
import { FunctionalButton } from "../../../components/functionalButton";
import CloseIcon from "@material-ui/icons/Close";
import { CloseButton } from "../../dashboard/styles";
import React, { useState } from "react";
import { StyledSpinner } from "../../../components/spinner/styles";
import PylonIcon from "../../../assets/common/pylonIcon.png";
import { FormTitle } from "../../homePage/styles";

type DeletePopupProps = {
  esubIdToDelete: number | null;
  setEsubIdToDelete: (id: number | null) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
  handleDelete: (id: number) => void;
  isDeleting: boolean;
};

export const DeletePopup = ({
  esubIdToDelete,
  setEsubIdToDelete,
  open,
  setOpen,
  handleDelete,
  isDeleting,
}: DeletePopupProps) => {
  const handleConfirmDelete = () => {
    if (esubIdToDelete) {
      handleDelete(esubIdToDelete);
    }
  };

  const handleClose = () => {
    setEsubIdToDelete(null);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      TransitionComponent={React.Fragment}
    >
      <StyledPaper elevation={0} style={{ width: "700px", height: "500px" }}>
        <CloseButton onClick={handleClose} aria-label="close">
          <CloseIcon />
        </CloseButton>
        {!isDeleting ? (
          <>
            <img src={PylonIcon} />
            <FormTitle style={{ margin: "15px 0" }}>
              Delete eSUB Confirmation
            </FormTitle>
            <SmallTitleText>
              Are you sure you want to delete this eSUB? This action is
              irreversible
            </SmallTitleText>
            <InfoArea>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  minWidth: "600px",
                  justifyContent: "center",
                }}
              >
                <FunctionalButton
                  buttonTitle="Cancel"
                  handleButton={handleClose}
                  width="250px"
                  height={undefined}
                  isReversedColor={true}
                  marginRight={undefined}
                  marginLeft={undefined}
                  marginTop={undefined}
                  marginBottom={undefined}
                  fontSize={undefined}
                  disabled={undefined}
                  icon={undefined}
                  hasBoxShadow={undefined}
                  frontIcon={undefined}
                  weight={undefined}
                  borderColor={undefined}
                  selected={undefined}
                />
                <FunctionalButton
                  buttonTitle="Confirm"
                  handleButton={handleConfirmDelete}
                  width="250px"
                  height={undefined}
                  isReversedColor={undefined}
                  marginRight={undefined}
                  marginLeft={undefined}
                  marginTop={undefined}
                  marginBottom={undefined}
                  fontSize={undefined}
                  disabled={undefined}
                  icon={undefined}
                  hasBoxShadow={undefined}
                  frontIcon={undefined}
                  weight={undefined}
                  borderColor={undefined}
                  selected={undefined}
                />
              </div>
            </InfoArea>
          </>
        ) : (
          <div style={{ width: "700px", height: "500px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >
              <StyledSpinner />
              <SmallTitleText style={{ marginTop: "20px" }}>
                Deleting eSUB
              </SmallTitleText>
            </div>
          </div>
        )}
      </StyledPaper>
    </Dialog>
  );
};
